<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div
        class="emp-button btn-align text-right"
        v-if="
          user &&
          (user.type == 'MANAGER' ||
            (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
        "
      >
        <button
          type="button"
          data-toggle="modal"
          data-target="#creat-employee"
          class="btn btn-outline-primary"
        >
          Create New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp p-0 bg-transparent">
        <div class="main-box hour-head-info">
          <div class="text-wrapper">
            <div class="hour-list">
              <div class="list-col">
                <span class="lable-text">Salary Component</span>
                <div class="form-group">
                  <select
                    class="form-select form-control"
                    id="employee"
                    name="employee"
                    required
                    v-model="selectedComponent"
                    @change="handleSelectChange"
                  >
                    <option value="" disabled selected>Select</option>
                    <option
                      :value="salaryComponent.name"
                      v-for="salaryComponent in salaryComponents"
                      :key="salaryComponent.id"
                      class="text-capitalize"
                    >
                      {{ salaryComponent.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-scroll" v-if="allSalaryComponentCalculations.length > 0">
          <table class="table">
            <tbody>
              <tr v-show="loadingSpin">
                <clip-loader
                  :loading="loadingSpin"
                  :size="size"
                  :color="spinnerColor"
                ></clip-loader>
              </tr>
              <tr v-show="calculationNotFound && loadingSpin == false">
                <td :colspan="6" class="text-center">No data found</td>
              </tr>
              <tr
                v-for="calculation in allSalaryComponentCalculations"
                :key="calculation.id"
              >
                <td>{{ moment(calculation.from_date).format("MMM YYYY") }}</td>
                <td>{{ calculation.type }}</td>
                <td>
                  {{
                    calculation.type === "Credit"
                      ? "-" + calculation.amount.toFixed(2)
                      : calculation.amount.toFixed(2)
                  }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>Total &nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;<strong>{{totalAmount}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-scroll" v-else>
          <table class="table">
            <tbody>
              <tr>
                <td :colspan="6" class="text-center">No data found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        <div></div>
        <br />
      </div>
      <createEmployeeModal></createEmployeeModal>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import employeeSidebar from "../Employees/employeeSidebar";
import createEmployeeModal from "../Employees/createEmployeeModal";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "employee-chart-account",
  components: {
    Multiselect,
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
    ClipLoader,
  },
  data() {
    return {
      employeeId: this.$store.getters.getEmployeeProfileId,
      employee: [],
      selectedCompany: this.$store.getters.getSelectedCompany,
      range: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      ],
      employees: [],
      from_date: "",
      to_date: "",
      form: {
        from_date: "",
        to_date: "",
        employee_id: "",
      },
      startDate: "",
      endDate: "",
      diff: [],
      size: "25px",
      spinnerColor: "#00779C",
      loadingSpin: false,
      hoursNotFound: false,
      calculationNotFound: false,
      user: this.$store.getters.getUser,
      salaryComponentCalculations: [],
      balance: 0,
      amount: "",
      payable: null,
      selectedEmployeeId: "",
      selectedComponent: "",
      salaryComponents: [],
      allSalaryComponentCalculations:[],
    };
  },
  computed: {
    totalAmount() {
      // Initialize sum to 0
      let sum = 0;

      // Loop through each calculation
      this.allSalaryComponentCalculations.forEach(calculation => {
        // If type is "Debit", subtract amount, otherwise add amount
        sum += calculation.type === "Credit" ? -calculation.amount : calculation.amount;
      });

      // Return the total sum with 2 decimal places
      return sum.toFixed(2);
    }
  },
  mounted() {
    this.$root.$emit("activeCompoClick");
    this.employee_id = this.$route.params.id || "";
    this.startDate = moment().startOf("month").format("YYYY-MM-DD");
    this.endDate = moment().endOf("month").format("YYYY-MM-DD");
    this.getSalaryComponents();
  },
  methods: {

    handleSelectChange() {
      this.getAllSalaryComponentsCalculation();
    },

    getAllSalaryComponentsCalculation()
    {
        var params = {
          employee_id: this.employeeId.id,
          company_id: this.selectedCompany.id,
          component: this.selectedComponent,
        };
        this.$axios
          .get(this.$GetAllSalaryComponentsCalculation, {
            params: params,
            headers: this.getAuthHeader(),
          })
          .then((response) => {
            this.allSalaryComponentCalculations = response.data.result;
            this.loadingSpin = false;
            this.calculationNotFound =
            this.allSalaryComponentCalculations.length === 0 ? true : false;
          })
          .catch((error) => {
            console.log(error);
          });

    },

    getSalaryComponents() {
      var params = {company_id: this.selectedCompany.id};
      this.$axios
        .get(this.$getSalaryComponents, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.salaryComponents = response.data.result;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
